overlays = {
	init: function(){
		$html = document.getElementsByTagName('html')[0];
		overlays.el();
	},
	el: function eventListenters(){
		$(".toggle-overlay").on("click", overlays.toggleOverlay);
		$(".overlay .btn-close").on("click", overlays.toggleOverlay);
		$(".close-on-click").on("click", overlays.toggleOverlay);
		$(".exit-modal").on("click", overlays.toggleOverlay);
		$("button[name='close-overlay']").on("click", overlays.toggleOverlay);

		// CLOSE MODAL ON CLICK OUTSIDE OF MODAL
		$('body').on('touchstart', function(e){
			if($html.classList.contains('overlay-showing')){
				if(!$(event.target).closest('.shell').length && !$(event.target).closest('.toggle-overlay').length && !$(event.target).is('.toggle-overlay')) {

					// if we have transforms available, lets get fancy
					if($("html").hasClass("csstransforms")){
						$(".show-overlay").addClass("hide-overlay");
						window.setTimeout(function(){
							$(".content").scrollTop(0);
							$(".show-overlay").removeClass("show-overlay hide-overlay");
							$html.classList.remove('overlay-showing');
						}, 1000);
					} else {
						// if no transforms, lets keep it simple
						$(".content").scrollTop(0);
						$(".show-overlay").removeClass("show-overlay");
						$html.classList.remove('overlay-showing');
					}
				} else {
					e.preventDefault(); e.stopPropagation();
				}
			}
		});
		$('body').on('touchmove', function(e){
			if($html.classList.contains('overlay-showing')){
				e.preventDefault(); e.stopPropagation();
			}
		});
		$('body').on('click', function(event){
			if(!$(event.target).closest('.shell').length && !$(event.target).closest('.toggle-overlay').length && !$(event.target).is('.toggle-overlay') && $(".show-overlay").length > 0) {
				// if we have transforms available, lets get fancy
				if($("html").hasClass("csstransforms")){
					$(".show-overlay").addClass("hide-overlay");
					window.setTimeout(function(){
						$(".content").scrollTop(0);
						$(".show-overlay").removeClass("show-overlay hide-overlay");
						$html.classList.remove('overlay-showing');
					}, 1000);
				} else {
					// if no transforms, lets keep it simple
					$(".content").scrollTop(0);
					$(".show-overlay").removeClass("show-overlay");
					$html.classList.remove('overlay-showing');
				}
			}
		});
		if(document.querySelector("#leaving.overlay .btn-continue")) {
			document.querySelector("#leaving.overlay .btn-continue").addEventListener('click', overlays.closeOverlay, false);
		}
		if(document.querySelector("#leaving-zocdoc.overlay .btn-continue")) {
			document.querySelector("#leaving-zocdoc.overlay .btn-continue").addEventListener('click', overlays.closeOverlay, false);
		}
	},
	toggleOverlay: function(evt){
		evt.preventDefault();

		var $this = $(this),
			thisButton = evt.currentTarget;
		var e = new Event('touchstart');
		if (!$this.hasClass('btn-close') && !$this.hasClass('close-on-click')){
			var modalToAttachEvent = document.getElementById($this.attr("data-overlay"));
			modalToAttachEvent.dispatchEvent(e);
		}


		if(arguments.length > 1){
			$("#" + overlays.toggleOverlay.arguments[1] + ".overlay").addClass("show-overlay");
			$html.classList.add('overlay-showing');
			return false;
		}

		if( $this.attr("data-overlay") && $this.attr("data-overlay").length > 0 ){
			// SHOW OVERLAY
			var overlay = $("#" + $this.attr("data-overlay") + ".overlay")[0];

			$(overlay).addClass("show-overlay");
			$html.classList.add('overlay-showing');

		} else {
			// if we have transforms available, lets get fancy
			if($("html").hasClass("csstransforms")){
				$this.parents(".overlay").addClass("hide-overlay");
				window.setTimeout(function(){
					$this.parents(".overlay").removeClass("show-overlay hide-overlay");
					$html.classList.remove('overlay-showing');
					$(".content").scrollTop(0);
				}, 1000);
			} else {
				// if no transforms, lets keep it simple
				$this.parents(".overlay").removeClass("show-overlay");
				$html.classList.remove('overlay-showing');
				$(".content").scrollTop(0);
			}
		}

		if(thisButton.hasAttribute('data-href')){
			/*
			 * If this toggle overlay button has a data-href attribute, then pass that into the overlay link
			 */
			document.querySelector("#" + thisButton.getAttribute('data-overlay')).querySelector('.btn-continue').setAttribute('href', thisButton.getAttribute('data-href'));

		}
	},
	closeOverlay: function(evt){
		$(".content").scrollTop(0);
		$(evt.target).parents(".overlay").removeClass("show-overlay");
		$html.classList.remove('overlay-showing');
	}
};